import { BasicCommand } from "./BasicCommand";
import { DependencyRule } from "./DependencyRule";
export class DependencyContext {
    private static readonly ruleMap = {};
    private static readonly principals: { [groupKey: string]: DependencyRule[] } = {};
    private static readonly dependents: { [groupKey: string]: DependencyRule[] } = {};
    private static readonly traversedCache: { [groupKey: string]: DependencyRule[] } = {};

    /**
     * @param groupKeyEntity Förälder kommandots groupKey
     *
     * Obs: Se till att primaryKey för kommandon delar en property med samma namn och värde
     */
    static entityHasRule<TPrincipal extends BasicCommand<TPrincipal>, TDependent extends BasicCommand<TDependent>>(groupKeyEntity: string, rule: DependencyRule) {
        this.ruleMap[groupKeyEntity] = (this.ruleMap[groupKeyEntity] || []);
        this.ruleMap[groupKeyEntity].push(rule);
        this.principals[rule.principal] = (this.principals[rule.principal] || []);
        this.principals[rule.principal].push(rule);
        this.dependents[rule.dependent] = (this.dependents[rule.dependent] || []);
        this.dependents[rule.dependent].push(rule);
    }

    static dependencies(groupKey: string) {
        if (this.traversedCache[groupKey] !== undefined) {
            return this.traversedCache[groupKey];
        }
        const principals = this.recursiveFetch(groupKey, "principal");
        const dependents = this.recursiveFetch(groupKey, "dependent");
        const results: DependencyRule[] = [];
        results.push(...principals);
        results.push(...dependents);
        this.traversedCache[groupKey] = results;
        return results;
    }

    static recursiveFetch(groupKey: string, property: keyof DependencyRule & ("principal" | "dependent")) {
        const results = [];
        let elements: DependencyRule[];
        const inverseProperty = property === "principal" ? "dependent" : "principal";
        if (property === "principal") {
            elements = this.principals[groupKey] || [];
        } else if (property === "dependent") {
            elements = this.dependents[groupKey] || [];
        } else {
            return [];
        }
        if (elements.length > 0) {
            results.push(...elements);
            elements.forEach(g => {
                results.push(...this.recursiveFetch(g[inverseProperty], property));
            });
        }
        return results;
    }
}
